import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]
  static values = { open: { type: Boolean, default: false } }

  connect() {
    if (!this.openValue) {
      this.contentTarget.classList.add("hidden")
    } else {
      this.iconTarget.classList.add("rotate-180")
    }
  }

  toggle() {
    this.contentTarget.classList.toggle("hidden")
    this.iconTarget.classList.toggle("rotate-180")
  }
}
